import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { OnboardDiagnosticService } from './onboard-diagnostic.service';
import { NgIf, NgFor, NgClass, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../shared/pipes/sort-by-filter.pipe';
import { FilterResultsPipe } from '../../shared/pipes/filter-results.pipe';
import { LoadMoreItemsPipe } from '../../shared/pipes/load-more-items.pipe';

@Component({
    selector: 'app-onboard-diagnostic',
    templateUrl: './onboard-diagnostic.component.html',
    styleUrls: ['./onboard-diagnostic.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        NgClass,
        FormsModule,
        NgStyle,
        SearchFilterPipe,
        SortByFilterPipe,
        FilterResultsPipe,
        LoadMoreItemsPipe,
    ],
})
export class OnboardDiagnosticComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscriptions: ISubscription[];
  public isShowAll = false;
  public isShowNew = true;
  public isShowHistory = false;
  public obdDocs: any;
  public docTitle: string;
  public obdDocContentObject: any;
  public newDocsCount: number;
  public expandOBDDoc = {};
  public sortBy = [];
  public obdDocTitles: string[];
  public serviceError = 'Loading data. Please wait...';
  public titleHighlighted: string;
  public search4obdDocs;
  public search4techDocs;

  public inputEngineGroup = '';
  public inputSortBy;
  public inputSeries = '';
  public makeYears = [];
  public inputYear;
  APP_SETTINGS: any;
  public filter = { engine: '', series: '', year: '' };

  // variables to update sort icons
  isDesc = false;
  column = '';
  direction: number;

  public numOfItems = 6;
  errorMessage: string;

  private username: string;

  constructor(
    private utilityService: UtilityService,
    private obdService: OnboardDiagnosticService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private spinnerService: SpinnerService,
    private cdr:ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    this.subscriptions = [];
    this.obdDocTitles = [];
    this.APP_SETTINGS = APP_SETTINGS;

    this.search4obdDocs = (APP_SETTINGS.currentPage == 'obd') ? this.obdService.getFilterData() : '';
    APP_SETTINGS.currentPage = 'obd';
    if (APP_SETTINGS.obd == 'all') { this.showAll(); }
    if (APP_SETTINGS.obd == 'new') { this.showNew(); }
    if (APP_SETTINGS.obd == 'history') { this.showHistory(); }
    this.obdDocs = [];
    const now = new Date();
    for (let i = 0, j = 1999; j <= now.getFullYear(); i++, j++) {
      this.makeYears[i] = j;
    }
    this.sortBy = [
      { key: 'engineFamily', value: 'Engine Family' },
      { key: 'productionDate', value: 'Date' }
    ];
    this.cdr.detectChanges();
  }

  showAll() {
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.obd = 'all';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.obdService.getAllOBDManuals().subscribe(data => {
      if (data && data.length !== 0) {
        this.obdDocs = data['content'];
        // get 1st object on loading and user hasn't made any selection yet
        this.obdDocContentObject = this.obdDocs[0]['content'];
        if (this.obdDocContentObject.length > 0) {
          for (var i = 0; i < this.obdDocContentObject.length; i++)
            this.obdDocContentObject[i]['engineAsString'] = this.obdDocContentObject[i].engines.map(value => value.engineName).join('');
        }
        this.newDocsCount = data['newSize'];
        this.docTitle = this.obdDocs[0]['title'];
        this.changeDetector.detectChanges();
      } else {
        this.obdDocs = [];
        this.obdDocContentObject = [];
        this.newDocsCount = 0;
        this.docTitle = '';
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.obd = 'new';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.obdService.getNewOBDManuals().subscribe(data => {
      if (data && data.length !== 0) {
        this.obdDocs = data;
        this.docTitle = data[0]['title'];
        this.obdDocContentObject = data[0]['content'];
        if (this.obdDocContentObject.length > 0) {
          for (var i = 0; i < this.obdDocContentObject.length; i++)
            this.obdDocContentObject[i]['engineAsString'] = this.obdDocContentObject[i].engines.map(value => value.engineName).join('');
        }
        // this.newDocsCount = this.obdDocContentObject.length;
        this.changeDetector.detectChanges();
      } else {
        this.obdDocs = [];
        this.obdDocContentObject = [];
        this.newDocsCount = 0;
        this.docTitle = '';
      }
      if (this.obdDocContentObject.length === 0) {
        this.errorMessage = 'No New OBD Documents';
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.errorMessage = '';
    APP_SETTINGS.obd = 'history';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.obdService.getUserOBDManualHistory(this.username).subscribe(data => {
      if (data && data.length !== 0) {
        this.obdDocs = data;
        this.docTitle = data[0]['title'];
        this.obdDocContentObject = data[0]['content'];
        if (this.obdDocContentObject.length > 0) {
          for (var i = 0; i < this.obdDocContentObject.length; i++)
            this.obdDocContentObject[i]['engineAsString'] = this.obdDocContentObject[i].engines.map(value => value.engineName).join('');
        }
        this.changeDetector.detectChanges();
      } else {
        this.obdDocs = [];
        this.obdDocContentObject = [];
        this.newDocsCount = 0;
        this.docTitle = '';
      }
      if (this.obdDocContentObject.length === 0) {
        this.errorMessage = 'No History Found';
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }
  loadDocContent(docObject) {
    this.docTitle = docObject.title;
    this.obdDocContentObject = docObject['content'];
    if (this.isShowNew) {
      this.newDocsCount = this.obdDocContentObject.length;
    }
  }

  saveToHistory(isSaved, docId, engineFamily) {
    this.obdService.saveFilterData(this.search4obdDocs);
    if (!isSaved) {
      this.subscriptions.push(this.obdService.addOBDManualToUserHistory(this.username, docId).subscribe(value => {
        if (value) {
        }
      }));
    }
    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('OBD', engineFamily, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('OBD', engineFamily);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('OBD', engineFamily, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('OBD', engineFamily, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }

  applyFilter() {
    this.filter = {
      engine: this.inputEngineGroup.trim(),
      series: this.inputSeries.trim(),
      year: this.inputYear
    };
    if (this.inputSortBy && this.inputSortBy.length > 0) {
      this.sortByProperty(this.inputSortBy);
    }
  }
  clearFilter() {
    this.inputEngineGroup = this.inputSeries = this.inputYear = '';
    this.filter = { engine: '', series: '', year: '' };
  }

  getProductionDateBounds(productionDates: string) {
    let prodDates = productionDates.split(',');
    if (prodDates.length < 2) {
      return productionDates;
    }
    prodDates = prodDates.sort((a, b) => {
      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      } else {
        return 0;
      }
    });
    return prodDates[0] + ' - ' + prodDates[prodDates.length - 1];
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
